import { Box } from '@mui/system'
import React from 'react'

const Feedback: React.FC = () => {
  return (
    <Box>
      <iframe
        src='https://docs.google.com/forms/d/e/1FAIpQLSfHiNGQL5SpnlkC9d613noKzHodesh0iEN-6jXDHf0NEM7F2w/viewform?embedded=true'
        width='640'
        height='1300'
        frameBorder='0'
        style={{ width: '100%', height: '100vh', border: 'none' }}
      >
        Loading…
      </iframe>
    </Box>
  )
}

export default Feedback
